export const environment = {
  production: true,
  buildId: '2644439714418151',
  configFile: 'config.json',
};
